/*
 * Preload/Intro animation JS for Homepage
 *
 * @author BarrelNY
 *
 */

var Intro = {
	init:function(){
		//What templates should trigger this module?
		var templates = [
			'body.home-page'
		].join();

		if (!$(templates).length) return;

		this.timerStarted = false;
		this.autoTransitioning = false;
		this.permanentlyStopTimer = false;

		this.el = '.intro[class^="section-"]';
		this.events();
	},

	setAnimations:function(){
		//Could use TweenMax instead
		//of Timeline but leaving it incase
		//we add to it later
		this.animation = new TimelineMax({
			onComplete:this.introComplete.bind(this)
		})
		.to($(this.el).find('.reveal'),4,{y:0},"+=1")
		.pause();
	},

	events:function(){
		$('body')
			.on('video__ready',this.videoReady.bind(this))
			.on('video__skipIntro',this.skipIntro.bind(this))
			.on('fullPage__afterRender',this.start.bind(this))
			.on('fullPage__onLeave',this.onLeave.bind(this))
			.on('fullPage__afterLoad',this.afterLoad.bind(this));
	},

	/*
	 * Add HTML that will create the
	 * animation intro
	 *
	 * @params	void
	 * @returns	void
	 */
	setupDOM:function(){
		this.$reveal = $('<div class="reveal">');
		this.$reveal.insertAfter($(this.el).find('img'));
	},

	/*
	 * Get things rolling
	 *
	 * @params	void
	 * @returns	void
	 */
	start:function(){
		this.setupDOM();
		this.setAnimations();

		$('body').trigger('fullPage__disableInteractions');
		$('body.home').addClass('show');

		this.animation.play(0);
	},

	/*
	 * The video is ready so let's skip the intro
	 *
	 * @params	void
	 * @returns	void
	 */
	skipIntro:function(){
		this.isSkipped = true;

		this.fadeOut();
	},

	/*
	 * The first part of the intro is complete
	 *
	 * @params	void
	 * @returns	void
	 */
	introComplete:function(){
		$(this.el).find('.reveal').addClass('gradient-animation');

		this.isComplete = true;

		//If we skippped the intro, don't execute
		if ( this.isSkipped )
			return;

		if ( MUR.videoStateCheck() || MUR.hideVideo() ){
			this.fadeOut();
		}
	},

	/*
	 * Handle the video ready event. Called
	 * in the video module via the 'canplaythrough'
	 * HTML5 Video API event
	 *
	 * @params	void
	 * @returns	void
	 */
	 videoReady:function(){
		 this.isVideoReady = true;

		 if (this.isComplete){
			 this.fadeOut();
		 }
	 },

	/*
	 * Fade out the element to display
	 * video underneath
	 *
	 * @params	void
	 * @returns	void
	 */
	fadeOut:function(){
		$('body').trigger('fullPage__enableInteractions');

		$('.video').addClass('show');
		$(this.el).find('.reveal').fadeOut(500);

		new TimelineMax()
			.fromTo($(this.el).find('.scroll-prompt'),1,{y:'-20px'},{y:0,opacity:1})
			.fromTo($(this.el).find('h1'),0.9,{opacity:0,y:-5},{opacity:1,y:0,ease: Power2.easeOut},0);

		this.setTimer();
	},

	/*
	 * Automate the scroll past the first two homepage slides
	 *
	 * @params	void
	 * @returns	void
	 */
	setTimer:function(){
		if (this.timerStarted || MUR.isSmall() || Modernizr.touch)
			return false;

		this.timerStarted = true;

		this.timer = setInterval( this.autoTransition.bind(this), 3000);
	},

	/*
	 * Stop the auto scroll timer
	 *
	 * @params	void
	 * @returns	void
	 */
	clearTimer:function(){
		clearInterval(this.timer);
	},

	/*
	 * Scroll the user down (auto transition)
	 *
	 * @params	void
	 * @returns	void
	 */
	autoTransition:function(){
		this.autoTransitioning = true;

		$.fn.fullpage.moveSectionDown();
	},

	/*
	 * Start the timer after the fullpage
	 * has landed on the next slide if
	 * the timer has been started, the timer
	 * has been permanently stopped or the
	 * current index is less than 3
	 *
	 * @param e event object
	 * @param anchorLink
	 * @param number the current slide index
	 * @returns	void
	 */
	afterLoad:function(e,anchorLink,index){
		if (!this.timerStarted)
			return;

		if (this.permanentlyStopTimer)
			return;

		if (
			index < 3
		){
			this.timerStarted = false;
			this.setTimer();
		}
	},

	/*
	 * Stop the timer just after we start
	 * to navigate to the next page. This is
	 * the way we can permanently stop the slideshow
	 * too
	 *
	 * @param e event object
	 * @param number the current slide index
	 * @returns	void
	 */
	onLeave:function(e, index){
		if (this.permanentlyStopTimer)
			return;

		if (!this.autoTransitioning){
			this.permanentlyStopTimer = true;
			this.clearTimer();
		}

		if (this.autoTransitioning && index < 3)
			this.clearTimer();

		this.autoTransitioning = false;
	},

	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop:function(){
		this.animations   = {};
		this.isVideoReady = false;
		this.isSkipped    = false;
		this.isComplete   = false;
		this.timerStarted = false;
		this.permanentlyStopTimer = false;

		this.clearTimer();

		$('body')
			.off('video__ready',this.videoReady)
			.off('video__skipIntro',this.skipIntro)
			.off('fullPage__afterRender',this.start);
	}

}

module.exports = Intro;
